import React, { useEffect, useState, useMemo, useCallback } from 'react';
import * as XLSX from 'xlsx';
import StepLevelBlocksViewer from './StepLevelBlocks'
import { fetchSingleObligationPayload } from './utils/payload'
import { toast } from 'react-toastify';
import TopHeaderViewer from './TopHeader';
import AuditTrailViewer from './AuditTrail'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useStyles from './style';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import SimpleTableViewer from './SimpleTable';
import SimpleAccordionViewer from './SimpleAccordion';
import SupplementalCommentsViewer from './SupplementalComments';
import OverviewCardViewer from './OverviewCard';
import ActionBarViewer from './ActionBar';
import CardInfoViewer from './CardInfo';
import HeadingBarViewer from './HeadingBar';
import SupplementalInfoModel from './SupplementalInfoModel';
import UploadCardViewer from './UploadCard';
import SpendViewer from './Spend';
import CommonTableViewer from './SummaryBlock/CommonTableViewer';
import PriceAdherenceDetails from './PriceAdherenceDetails';
import LinkedTables from './LinkedTables';
import CommonLinkedInBuiltTable from './CommonLinkedInBuiltTable';


const ObligationViewer = (props) => {
  const { data, formData } = props;
  const { chartData, chartUniqueId } = data || {};
  const { tabs } = chartData || {};
  const { opportunity, contract, supplementary, spendDetails, priceAdherenceDetails } = tabs || {};
  const { blocks, selectedDataModel, workflowId, workflowEnable, ContractsdataElement, LinkedContractsdataElements, PortfolioInfo, VendorInfo, LinkedObligationdataElements, topHeaderdataElements, LinkedSpenddataElements, isCommentSectionEnable, isLinked, isSideBar, sidebar } = chartData || {};
  const currentDocumentId = props?.match?.params?.id;
  const [json, setJson] = useState({});
  const [blockState, setBlockState] = useState(json)
  const [enabledBlocks, setEnabledBlocks] = useState([])
  const [currentDataModel, setCurrentDataModel] = useState({})
  const [accordionSupport, setAccordionSupport] = useState({})
  const [tableData, setTableData] = useState([]);
  const [activeTab, setActiveTab] = useState('contract');
  const [enableEdit, setEnableEdit] = useState(false)
  const [auditTrail, setAuditTrail] = useState([])
  const [attachments, setAttachments] = useState([])
  const [activeTabMain, setActiveTabMain] = useState(chartData?.defaultTab || 'opportunityDetails');
  const [auditTrailDrawerOpen, setAuditTrailDrawerOpen] = useState(false);
  const [isInfoModel, setIsInfoModel] = useState(false);
  const classes = useStyles();

  const [editingIndex, setEditingIndex] = useState({
    index: null,
    editMode: false,
    openMode: false,
    viewMode: false
  });
  const [formDataModeInfoModel, setFormDataModeInfoModel] = useState({});

  const selectedStep = {
    dataModel: selectedDataModel,
    blocks: blocks
  }

  const stableBlocks = useMemo(() => blocks, [JSON.stringify(blocks)]);


  useEffect(() => {
    if (selectedStep?.blocks?.length) {
      let accordion = {};
      let b = selectedStep.blocks.filter((block => {
        if (block.accordion) {
          accordion[block.name] = block.accordion
        }
        return block.enable
      }))
      setEnabledBlocks(b)
      setAccordionSupport(accordion)
      getWorkflow(workflowId)
      fetchContractDataModel(contract?.uploadCard?.block?.dataModel)
      fetchDataModel()
      getAllAttachmentsOfOpportunity()
      fetchSingleObligation()
      props.getAuditTrailsData({
        dataModelId: selectedDataModel,
        appId: props.match.params.appid,
        documentId: props.match.params.id,
        dataUniqueId: chartUniqueId + '_audit_Trails_Obligations'
      })
    }
  }, [stableBlocks])

  const clearCurrentChartReduxStore = () => {
    let subKeys = [
      props.data.chartUniqueId + '_execute_obligation_Workflow',
      props.data.chartUniqueId + '_Obligations_Next_Respondent',
      props.data.chartUniqueId + '_obligation_executeWorkflow_reject',
      props.data.chartUniqueId + '_Obligations_Step_Assigning_Upated',
      props.data.chartUniqueId + '_Current_Steps_Members',
      props.data.chartUniqueId + '_getsingleobligation',
      props.data.chartUniqueId + '_audit_Trails_Obligations',
      props.data.chartUniqueId + '_documentsfromIds',

    ]
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: subKeys
    })
  }


  useEffect(() => {

    return (() => {
      clearCurrentChartReduxStore()
    })
  }, [])

  useEffect(() => {
    if (props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Obligations']) {
      let obj = props.formData?.auditTrails[chartUniqueId + '_audit_Trails_Obligations'] || {}
      setAuditTrail(obj)
    }
  }, [props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Obligations']])

  const getAuditTrailsData = () => {
    props.getAuditTrailsData({
      dataModelId: selectedDataModel,
      appId: props.match.params.appid,
      documentId: props.match.params.id,
      dataUniqueId: chartUniqueId + '_audit_Trails_Obligations'
    })
  }
  const normalizeDateFields = (obj) => {
    const normalized = {};
    for (const key in obj) {
      const value = obj[key];
      if (typeof value === 'string') {
        const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})[T ]/);
        if (isoMatch) {
          normalized[key] = isoMatch[1];
          continue;
        }
      }
      normalized[key] = value;
    }
    return normalized;
  };

  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_getsingleobligation']) {
      getAuditTrailsData()
      getAllAttachmentsOfOpportunity()
      let obj = props.formData?.document[chartUniqueId + '_getsingleobligation'] || {}
      if (obj['workflow']) {
        fetchTasks(workflowId, obj['workflow']?.id)
      }
      const formattedObj = normalizeDateFields(obj);
      setJson(formattedObj);
      if (formattedObj[ContractsdataElement]) {
        filterDocIds(formattedObj)
      }
      setBlockState(formattedObj)
    }
  }, [props.formData?.document[chartUniqueId + '_getsingleobligation']])

  const fetchTasks = (workflowId, currentTaskId) => {
    if (currentTaskId && workflowId) {
      let payload = {
        workflowId: workflowId,
        currentTaskId: currentTaskId,
        appId: props.match.params.appid,
        dataUniqueId: chartUniqueId + '_obligation_next_step',
        data: {
          docId: props.match.params.id,
          dmId: selectedDataModel
        }
      }
      props.getNextTasks(payload)
    }
  }
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getContractHierarchys = (documentId, dataModelId, version, fields, dataUniqueId) => {
    console.log('getContractHierarchys**dataModelId', dataModelId, documentId, version, fields, dataUniqueId)
    props.getContractHierarchys({
      appId: props.match.params.appid,
      dataModelId,
      documentId: documentId,
      version: version,
      payload: {
        fields: fields,
      },
      dataUniqueId: dataUniqueId,
      isOpportunityHierarchy: true
    });
  }

  const filterDocIds = (res) => {
    let linkedData = res[ContractsdataElement] || [];
    let docIdsList = []
    linkedData && linkedData.length && linkedData.forEach(obj => {
      if (obj.dataModel) {
        fetchContractDataModel(obj.dataModel)
        docIdsList = obj.documents;
      }
    });
    docIdsList?.forEach(docId => {
      if (contract?.contractHierarchies?.enable) {
        getContractHierarchys(docId, linkedData?.[0]?.dataModel, "V2", contract?.contractHierarchies?.selectedDataElement?.map(i => i?.value).join(','), `${chartUniqueId}_${docId}_contract_hierarchies`,)
      }
    })
    if (linkedData.length > 0) {
      if (contract?.enable) {
        getDocsfromIds(docIdsList, linkedData?.[0]?.dataModel)
      }
    }

  }

  const getDocsfromIds = (docIdsList, dataModel) => {
    if (docIdsList && docIdsList.length > 0) {
      const multipleCardFields = (contract?.multipleCard || [])
        .map(mc => Object.values(mc || {})[0]?.value)
        .filter(Boolean);

      // Collect linkedFields (linkedFrom: contractDetails) values + ${placeholder} keys from opportunity blocks
      const linkedFieldsForContracts = [];
      const collectLinkedFields = (elements) => {
        (elements || []).forEach((el) => {
          const custom = el?.isCustomType;
          if (!(custom?.enable && custom?.type === 'linkedFields' && custom?.linkedFrom === 'contractDetails')) return;
          if (custom?.value) linkedFieldsForContracts.push(custom.value);
          const titleMatches = String(custom?.title || '').matchAll(/\$\{([^}]+)\}/g);
          for (const match of titleMatches) {
            if (match?.[1]) linkedFieldsForContracts.push(match[1]);
          }
        });
      };
      (stableBlocks || blocks || []).forEach((block) => {
        collectLinkedFields(block?.config?.dataElements);
        (block?.subBlock || []).forEach((sub) => collectLinkedFields(sub?.config?.dataElements));
      });

      const fields = [
        ...(contract?.cardInformation?.selectedDataElement?.map(i => i.value) || []),
        ...(LinkedContractsdataElements?.map(i => i.value) || []),
        ...(contract?.dataElements?.map(i => i.value) || []),
        PortfolioInfo,
        VendorInfo,
        ...(contract?.obligationManagement?.selectedDataElement?.map(i => i.value) || []),
        ...(contract?.clause?.selectedDataElement?.map(i => i.value) || []),
        ...multipleCardFields,
        contract?.accordionSupport?.AccordionDetailsHeader?.value,
        ...linkedFieldsForContracts,
      ]?.filter(Boolean).join(',');
      let payload = {
        fields,
        docIds: docIdsList,
        appId: props.match.params.appid,
        id: dataModel
      };
      if (!props.formData?.document[chartUniqueId + '_documentsfromIds']) {
        props.getDocumentsFromIDsOfOpportunity({ ...payload, dataUniqueId: chartUniqueId + '_documentsfromIds' });
      }

    }
  }


  useEffect(() => {
    if (formData?.document[chartUniqueId + '_documentsfromIds']?.length) {
      let dataList = formData?.document[chartUniqueId + '_documentsfromIds'] || []
      dataList = dataList?.map(item => {
        let obj = {};
        if (formData?.document[`${chartUniqueId}_${item._id}_contract_hierarchies`]) {
          obj[contract?.contractHierarchies?.name] = formData?.document[`${chartUniqueId}_${item?.["_id"]}_contract_hierarchies`] || [];
        }
        obj["id"] = item?.["_id"];
        Object.entries(item).forEach(([key, value]) => {
          const matchingObligationElement = contract?.obligationManagement?.selectedDataElement.find(element => element.value === key);

          if (matchingObligationElement) {
            if (!obj[contract?.obligationManagement?.name]) {
              obj[contract?.obligationManagement?.name] = {};
            }
            obj[contract?.obligationManagement?.name][key] = value;
          }

          const matchingClauseElement = contract?.clause?.selectedDataElement.find(element => element.value === key);
          if (matchingClauseElement) {
            if (!obj[contract?.clause?.name]) {
              obj[contract?.clause?.name] = {};
            }
            obj[contract?.clause?.name][key] = value;
          }

          const matchingCardInfoElement = contract?.cardInformation?.selectedDataElement.find(element => element.value === key);
          if (matchingCardInfoElement) {
            if (!obj[contract?.cardInformation?.name]) {
              obj[contract?.cardInformation?.name] = {};
            }
            obj[contract?.cardInformation?.name][key] = value;
          }

          const matchingMultipleCardElement = (contract?.multipleCard || []).some(mc => Object.values(mc || {})[0]?.value === key);
          if (matchingMultipleCardElement) {
            obj[key] = value;
          }

          if (!matchingObligationElement && !matchingClauseElement && !matchingCardInfoElement && !matchingMultipleCardElement) {
            obj[key] = value;
          }
        })

        return obj
      })
      setTableData(dataList)
    }
  }, [props.formData?.document[chartUniqueId + '_documentsfromIds'], formData?.document])


  useEffect(() => {
    const updatedData = props.formData?.document?.[`${chartUniqueId}_rejected_obligation`];
    if (updatedData) {
      toast.success(updatedData?.message || 'This Obligation is Rejected')
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${chartUniqueId}_rejected_obligation`]
      })
      fetchSingleObligation();
    }
  }, [props.formData?.document?.[`${chartUniqueId}_rejected_obligation`]])

  useEffect(() => {
    const updatedData = props.formData?.document?.[`${chartUniqueId}_accepted_obligation`];
    if (updatedData) {
      toast.success(updatedData?.message || 'This Obligation is Accepted')
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${chartUniqueId}_accepted_obligation`]
      })
      fetchSingleObligation();
    }
  }, [props.formData?.document?.[`${chartUniqueId}_accepted_obligation`]])


  const getWorkflow = (workflowId) => {
    let payload = {
      id: workflowId,
      dataUniqueId: `${chartUniqueId}_obligation_workflows`,
      appId: props.match.params.appid,
    }
    props.getWorkflowById(payload)
  }

  const fetchSingleObligation = () => {
    if (!props.formData?.document[chartUniqueId + '_getsingleobligation']) {
      let payload = fetchSingleObligationPayload(props.appId, props.orgId, selectedStep, props.match.params.id, chartUniqueId)
      props.getSingleOpportunity(payload)
    }
  }

  const fetchDataModel = () => {
    let payload = {
      appid: props.appId,
      orgId: props.orgId
    }
    if (selectedStep?.dataModel) {
      if (!formData?.dataModel?.[selectedStep.dataModel]) {
        if (!formData?.dataModel?.[selectedStep.dataModel] && !formData[`${selectedStep.dataModel}_loading`]) {
          payload['dataModelId'] = selectedStep.dataModel
          payload['dataUniqueId'] = selectedStep.dataModel
          props.getDataModelById(payload)
        }
      } else {
        setCurrentDataModel(formData?.dataModel?.[selectedStep.dataModel])
      }
    }
  }

  const fetchContractDataModel = (dataModel) => {
    console.log('fetchContractDataModel**dataModel', dataModel, props)
    let payload = {
      appid: props.appId,
      orgId: props.orgId
    }
    if (dataModel) {
      if (!formData?.dataModel?.[dataModel]) {
        if (!formData?.dataModel?.[dataModel] && !formData[`${dataModel}_loading`]) {
          payload['dataModelId'] = dataModel
          payload['dataUniqueId'] = dataModel
          props.getDataModelById(payload)
        }
      }
    }
  }

  const handleOnChange = (name, value, type, uiFieldType, header, valueObj) => {
    setEnableEdit(true);
    let v = value;
    if (header?.type === 'namepicker' && valueObj) {
      v = {
        id: valueObj?._id,
        name: valueObj?.name
      }
    }

    if (header?.type == 'comments') {
      setCommentTypeFieldState({
        ...commentTypeFieldState,
        [header.value || header.name]: v
      })
    } else {
      setBlockState({
        ...blockState,
        [name]: v
      })
    }
  }

  const handleCheckboxChange = (name, value) => {
    setEnableEdit(true);
    setBlockState(prevBlockState => {
      const currentArr = Array.isArray(prevBlockState[name]) ? prevBlockState[name] : [];
      const newArr = currentArr.includes(value)
        ? currentArr.filter((v) => v !== value)
        : [...currentArr, value];
      return { ...prevBlockState, [name]: newArr };
    });
  };

  const onRejectObligation = (rejectedComment) => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_rejected_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        status: 'Rejected',
        rejectedComment: rejectedComment || '',
      },
      orgId: props.orgId
    }
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_getsingleobligation`]
    })
    props.rejectedWorkFlowObligations(payload)
  }

  const completedWorkFlowObligations = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_completed_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        status: 'Completed'
      },
      orgId: props.orgId
    }
    props.completedWorkFlowObligations(payload)

  }

  const onAcceptObligation = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_accepted_obligation`,
      obligationId: props.match.params.id,
      dataModelId: selectedDataModel,
      appId: props.appId,
      data: {
        workFlowId: workflowId
      },
      orgId: props.orgId
    }
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_getsingleobligation`]
    })
    props.acceptWorkFlowObligations(payload)
  }


  const removeIdFields = (obj) => {
    if (Array.isArray(obj)) {
      obj.forEach(removeIdFields);
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj._id) {
        delete obj._id;
      }
      Object.keys(obj).forEach((key) => {
        removeIdFields(obj[key]);
      });
    }
  };
  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_updateobligation']?._id) {
      let obj = props.formData?.document[chartUniqueId + '_updateobligation'] || {};
      toast.success(obj.message || 'Document Updated Successfully')
      const formattedObj = normalizeDateFields(obj);

      getAuditTrailsData()
      getAllAttachmentsOfOpportunity()

      if (obj?.[ContractsdataElement]) {
        filterDocIds(obj)
      }

      setJson(formattedObj);
      setBlockState(formattedObj);
    } else {
      console.log('Error in Update Identify Step');
    }
  }, [props.formData?.document[chartUniqueId + '_updateobligation']]);

  const onSaveClick = () => {
    let data = JSON.parse(JSON.stringify(blockState))
    removeIdFields(data)
    data["isSaveHistory"] = true;
    let formData = {
      appId: props.appId,
      dataModelId: chartData?.selectedDataModel,
      dataUniqueId: props.data.chartUniqueId + '_updateobligation',
      opportunityId: props.match.params.id,
      payload: data,
    }
    props.updateOpportunity(formData)
  }

  const onSaveClickV2 = (updatedData) => {
    let data = JSON.parse(JSON.stringify(updatedData))
    removeIdFields(data)
    data["isSaveHistory"] = true;
    let formData = {
      appId: props.appId,
      dataModelId: chartData?.selectedDataModel,
      dataUniqueId: props.data.chartUniqueId + '_updateobligation',
      opportunityId: props.match.params.id,
      payload: data,
    }
    props.updateOpportunity(formData)
  }

  const handleSave = () => {
    setEnableEdit(false)
    onSaveClick()
  }

  const getAllAttachmentsOfOpportunity = () => {
    const payload = {
      appId: props.appId,
      orgId: props.orgId,
      dataModelId: chartData?.selectedDataModel,
      subDataModelId: supplementary?.attachments?.dataModel,
      opportunityId: props.match.params.id,
      dataUniqueId: `${chartUniqueId}_uploaded_lists_file`
    };
    props.getAllActionsOfOpportunity(payload);
  }

  useEffect(() => {
    const list = props.formData?.document?.[`${chartUniqueId}_uploaded_lists_file`];
    if (list) {
      setAttachments(list)
    }
  }, [props.formData?.document?.[chartUniqueId + '_uploaded_lists_file']])

  const handleAuditTrailDrawerToggle = () => {
    setAuditTrailDrawerOpen(!auditTrailDrawerOpen);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} hours ago`;

    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} days ago`;
  };

  const handleCloseModeInfoModel = () => {
    setIsInfoModel(false);
    setEditingIndex({
      index: null,
      editMode: false,
      openMode: false,
      viewMode: false
    });
  };
  const handleOpenModeInfoModel = () => {
    setFormDataModeInfoModel({});
    setEditingIndex({
      editMode: false,
      openMode: true,
      viewMode: false,
      index: null,
    });
    setIsInfoModel(true);
  };

  const handleGlobalDownloadSupplementalInformation = useCallback(() => {
    const rows = blockState?.supplementalInformation;
    if (!Array.isArray(rows) || rows.length === 0) {
      toast.info('No supplementary information to download.');
      return;
    }
    const columns =
      supplementary?.supplementalInformation?.dataElement?.TableSelectedDataElement || [];
    if (!Array.isArray(columns) || columns.length === 0) {
      toast.warn('Supplementary table columns are not configured.');
      return;
    }
    const columnDefs = columns.filter((c) => c && c.value);
    if (columnDefs.length === 0) {
      toast.warn('Supplementary table columns are not configured.');
      return;
    }
    const keys = columnDefs.map((c) => c.value);
    const headerRow = columnDefs.map((c) => (c.label != null && c.label !== '' ? c.label : c.value));
    const cellText = (v) => {
      if (v == null) return '';
      if (typeof v === 'object' && v !== null && Object.prototype.hasOwnProperty.call(v, 'value')) {
        return v.value != null ? String(v.value) : '';
      }
      return String(v);
    };
    const dataRows = rows.map((row) => keys.map((key) => cellText(row[key])));
    const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, 'Supplementary');
    const rawTitle = supplementary?.supplementalInformation?.title || 'supplementary_information';
    const safeName = String(rawTitle).replace(/[^\w\-]+/g, '_').slice(0, 80) || 'supplementary_information';
    XLSX.writeFile(wb, `${safeName}.xlsx`);
  }, [blockState, supplementary]);

  const handleOnSupplementalInfoModelFieldChange = (name, value) => {
    setFormDataModeInfoModel((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === 'dataType' && prev.value !== undefined) {
        updated.value = convertValue(prev.value, value);
      }
      return updated;
    });
  };

  const handleSaveModeInfoModel = () => {
    const newDataPoint = {};
    supplementary?.supplementalInformation?.dataElement?.formSelectedDataElement?.forEach((element) => {
      const val = formDataModeInfoModel[element.value];
      if (val !== undefined && val !== null) {
        if (element.value === 'value') {
          const dataType = formDataModeInfoModel.dataType || 'string';
          newDataPoint[element.value] = convertValue(val, dataType);
        } else {
          newDataPoint[element.value] = val;
        }
      }
    });

    const currentData = blockState?.["supplementalInformation"] || [];
    let updatedData;

    if (editingIndex?.index !== null) {
      // Update existing row
      updatedData = [...currentData];
      updatedData[editingIndex?.index] = newDataPoint;
    } else {
      // Add new row
      updatedData = [...currentData, newDataPoint];
    }


    const updatedBlockState = {
      ...blockState,
      supplementalInformation: updatedData
    };
    onSaveClickV2(updatedBlockState);

    setFormDataModeInfoModel({});
    setEditingIndex({
      index: null,
      editMode: false,
      openMode: false,
      viewMode: false
    });
    handleCloseModeInfoModel();
  };

  const convertValue = (value, dataType) => {
    if (value === null || value === undefined || value === '') {
      return dataType === 'number' ? 0 : '';
    }
    if (dataType === 'number') {
      const numValue = parseFloat(value);
      return isNaN(numValue) ? 0 : numValue;
    }
    return String(value);
  };
  const handleEditModeInfoModel = (row, index) => {
    // console.log('tableData**ObligationViewer**handleEditModeInfoModel', row, index)
    setFormDataModeInfoModel(row);
    setEditingIndex({
      index: index,
      editMode: true,
      openMode: false,
      viewMode: false
    });
    // handleOpenModeInfoModel();
    setIsInfoModel(true);
  };
  const handleDeleteModeInfoModel = (row, index) => {
    const currentData = blockState?.["supplementalInformation"] || [];
    const updatedData = currentData.filter((_, i) => i !== index);
    onSaveClickV2({
      ...blockState,
      supplementalInformation: updatedData
    });
  };
  const handleDownloadAttachments = (e, item) => {
    e.preventDefault();
    console.log('item**', item)
    props.downloadContractPDFAction({
      appid: props.appId,
      isDownload: true,
      openFile: false,
      pdfLoadRefresh: false,
      noType: true,
      dataModelId: supplementary?.attachments?.dataModel,
      field: 'path',
      modelDataType: 'attachments',
      "_id": item['_id'],
      dataUniqueId: "quickView_Attachments_download"
    });
  };

  useEffect(() => {
    fetchSingleObligation()
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_upload_attachments_opp`]
    })
  }, [props.formData?.document[chartUniqueId + '_upload_attachments_opp']]);

  useEffect(() => {
    fetchSingleObligation()
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId} _delete_attachments_file`]
    })
  }, [props.formData?.document[chartUniqueId + '_delete_attachments_file']]);

  const handleDeleteAttachments = (e, item) => {
    e.preventDefault();
    const idsArray = [item['_id']];
    const result = { ids: idsArray };
    const payload = {
      appId: props.appId,
      orgId: props.orgId,
      dataModelId: props.data?.chartData?.selectedDataModel,
      subDataModelId: supplementary?.attachments?.dataModel,
      opportunityId: props?.match?.params?.id || currentOpportunityId,
      data: result,
      dataUniqueId: `${chartUniqueId}_delete_attachments_file`
    };
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_getsingleobligation`]
    })
    props.deleteAttachmentsForOpportunity(payload);
  };

  const handleRemoveDocuments = (documentId, data) => {

    const existingLinkedRefs = blockState?.linkedReferenceDocuments ? [...blockState?.linkedReferenceDocuments] : [];

    console.log('documentId**handleRemoveDocuments', documentId, data, contract?.uploadCard?.blocks?.dataModel, existingLinkedRefs)

    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_${documentId}_contract_hierarchies`]
    })

    const updatedLinkedRefs = existingLinkedRefs.map(item => {
      if ((item.dataModel === contract?.uploadCard?.block?.dataModel) && item.documents) {
        return {
          ...item,
          documents: item.documents.filter(docId => docId !== documentId)
        };
      }
      return item;
    }).filter(item => item.documents && item.documents.length > 0);


    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${chartUniqueId}_documentsfromIds`]
    })

    setTableData([])
    onSaveClickV2({
      ...blockState,
      linkedReferenceDocuments: updatedLinkedRefs
    });
  }


  const handleExport = (id, item) => {
    let payload = {
      dataModelId: selectedDataModel,
      appid: props.match.params.appid,
      fields: opportunity?.actionBar?.ActionButton?.export?.exportdataElement?.map(i => i.value).join(","),
      ids: [id],
      downloadType: 'excel',
      dataUniqueId: props.data.chartUniqueId + '_' + id + '_download_single_opportunity',
    }
    props.downloadSheet(payload);
  }

  const handleExportBundle = (id, item) => {
    let payload = {
      dataModelId: selectedDataModel,
      appid: props.match.params.appid,
      downloadType: 'excel',
      ids: [id],
      pageUrl: props.page?.url,
      dataUniqueId: props.data.chartUniqueId + '_' + 'selected_spend_download',
      // isDownloadV2Call: true
    }
    props.downloadSheetBundleOpportunity(payload);
  }

  const handleViewAttachments = (item, index) => {
    setFormDataModeInfoModel(item);
    setEditingIndex({
      index: index,
      editMode: false,
      openMode: false,
      viewMode: true
    });
    setIsInfoModel(true);
  }

  return (

    (props.formData?.[chartUniqueId + '_getsingleobligation_loading'] || props.formData?.[chartUniqueId + '_updateobligation_loading'] || props.formData?.[chartUniqueId + '_accepted_obligation_loading'] || props.formData?.[chartUniqueId + '_rejected_obligation_loading']) ? props.loader : (
      <div className={classes.container}>
        <Grid container className={classes.headerGrid}>
          <Grid item xs={12} className={classes.headerRow}>
            <TopHeaderViewer {...props} setActiveTabMain={setActiveTabMain} activeTabMain={activeTabMain} blockState={blockState} />
          </Grid>
          {
            blockState?.['status'] === 'Rejected' && (
              <div style={{ marginBottom: '12px', marginTop: '20px', width: '100%' }}>
                <Alert severity="error" variant="filled" classes={{ root: classes.alertRoot, message: classes.message, icon: classes.icon }}>
                  <div>{`This document has been Rejected by ${blockState?.['rejectedBy']?.name}.`}</div>
                </Alert>
                {blockState?.['rejectedComment'] && <div style={{ marginTop: 6, padding: '6px 10px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: 6, fontSize: 13 }}><span style={{ fontWeight: 700 }}>Reason:</span> {blockState['rejectedComment']}</div>}
              </div>
            )
          }
          <Grid container className={classes.mainGrid}>
            {
              (
                <Grid item xs={12} md={12} className={`${classes.main} ${classes.mainCol} myScrollContainer`}>
                  {activeTabMain === 'opportunityDetails' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                      <OverviewCardViewer {...props} src={opportunity?.overview?.src} title={opportunity?.overview?.title} description={opportunity?.overview?.description} />

                      <ActionBarViewer {...props} isButtonEnable={opportunity?.actionBar?.ActionButton?.enable} isExport={opportunity?.actionBar?.ActionButton?.export?.enable} isAuditTrail={opportunity?.actionBar?.ActionButton?.auditTrail?.enable} handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} auditTrailDrawerOpen={auditTrailDrawerOpen} auditTrail={auditTrail} chartUniqueId={chartUniqueId} label={opportunity?.actionBar?.actionHeader?.label} value={opportunity?.actionBar?.actionHeader?.value} blockState={blockState} exportLabel={opportunity?.actionBar?.ActionButton?.export?.label} auditTrailLabel={opportunity?.actionBar?.ActionButton?.auditTrail?.label} handleExport={handleExport} auditTrailDownloadInfo={opportunity?.actionBar?.ActionButton?.auditTrail} isGobalDownloadEnable={true} onGlobalDownload={() => { }} globalDownloadTitle={false} handleExportBundle={handleExportBundle} />

                      <CardInfoViewer {...props} data={opportunity?.uploadCard?.dataElement} blockState={blockState} />

                      <div className={classes.clauseWrap}>
                        <StepLevelBlocksViewer
                          {...props}
                          currentDocumentId={currentDocumentId}
                          blocks={enabledBlocks}
                          selectedStep={selectedStep}
                          blockState={blockState}
                          handleSave={handleSave}
                          currentDataModel={currentDataModel}
                          accordionSupport={accordionSupport}
                          setAccordionSupport={setAccordionSupport}
                          onChange={handleOnChange}
                          enableEdit={enableEdit}
                          handleCheckboxChange={handleCheckboxChange}
                          enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false}
                          onRejectObligation={onRejectObligation}
                          isCommentSectionEnable={isCommentSectionEnable}
                          onAcceptObligation={onAcceptObligation}
                          isLinked={isLinked}
                          fetchSingleObligation={fetchSingleObligation}
                          completedWorkFlowObligations={completedWorkFlowObligations}
                          enableRejectButton={blockState?.actions?.length ? true : false}
                          nextStep={formData?.document?.[chartUniqueId + '_obligation_next_step'] ? formData?.document?.[chartUniqueId + '_obligation_next_step'] : {}}
                          CurrentObligationWorkflow={blockState?.workflow ? blockState?.workflow : {}}
                          obligationWorkflowObject={props.formData?.document[chartUniqueId + '_obligation_workflows'] ? (props.formData?.document[chartUniqueId + '_obligation_workflows']?.['diagram']?.['steps']) : []}
                          setActiveTabMain={setActiveTabMain}
                          tableData={tableData}
                        />
                      </div>
                    </div>

                  )}
                  {activeTabMain === 'contractDetails' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                      <OverviewCardViewer {...props} src={contract?.overview?.src} title={contract?.overview?.title} description={contract?.overview?.description} />
                      <UploadCardViewer {...props} block={contract.uploadCard.block} isEditable={true} blockState={blockState} onSaveClickV2={onSaveClickV2} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} isContractUnavailable={chartData?.isContractUnavailable} />
                      <SimpleAccordionViewer {...props} blockState={blockState} tableData={tableData} handleRemove={handleRemoveDocuments} linkedContractsdataElements={LinkedContractsdataElements} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} contract={contract} isContractUnavailable={chartData?.isContractUnavailable} />
                    </div>
                  )}

                  {
                    activeTabMain === 'spendDetails' && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <SpendViewer {...props} spendDetails={spendDetails} blockState={blockState} enableWorkflow={props.enableWorkflow} activeTabMain={activeTabMain} />
                      </div>
                    )
                  }

                  {
                    activeTabMain === 'priceAdherenceDetails' && (
                      priceAdherenceDetails?.isCustomType?.enable && priceAdherenceDetails?.isCustomType?.type === "table" && priceAdherenceDetails?.isCustomType?.isInlineObject && priceAdherenceDetails?.isFetchAPI !== true ? (
                        <CommonTableViewer {...props} title={priceAdherenceDetails?.isCustomType?.title} data={blockState?.[priceAdherenceDetails?.isCustomType?.value] || []} element={priceAdherenceDetails?.isCustomType} />
                      ) : (
                        <PriceAdherenceDetails {...props} activeTabMain={activeTabMain} priceAdherenceDetails={priceAdherenceDetails} blockState={blockState} />
                      )
                    )
                  }

                  {
                    activeTabMain.includes('_linked_tables') &&
                    (() => {
                      const tabDef = tabs?.[activeTabMain];
                      return tabDef ? <LinkedTables {...props} activeTabMain={activeTabMain} tabDef={tabDef} blockState={blockState} /> : null;
                    })()

                  }

                  {
                    activeTabMain.includes('_linked_inbuilt_tables') &&
                    (() => {
                      const tabDef = tabs?.[activeTabMain];
                      return tabDef ? <CommonLinkedInBuiltTable {...props} title={tabDef?.isCustomType?.title} data={blockState?.[tabDef?.isCustomType?.value] || []} element={tabDef?.isCustomType} /> : null;
                    })()

                  }

                  {activeTabMain === 'supplementary' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                      <OverviewCardViewer {...props} src={supplementary?.overview?.src} title={supplementary?.overview?.title} description={supplementary?.overview?.description} />

                      <HeadingBarViewer {...props} title={supplementary?.supplementalInformation?.title} buttonLabel={supplementary?.supplementalInformationHeader?.actionButton?.label} onButtonClick={handleOpenModeInfoModel} isAttachmentsButton={supplementary?.supplementalInformationHeader?.isAttachmentsButton} blockState={blockState} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} blockConfig={supplementary?.supplementalInformation} isGlobalDownloadEnable={supplementary?.supplementalInformationHeader?.isGlobalDownloadEnable} isGobalDownloadEnable={Array.isArray(blockState?.supplementalInformation) && blockState.supplementalInformation.length > 0 && supplementary?.supplementalInformationHeader?.isGlobalDownloadEnable !== false && supplementary?.supplementalInformationHeader?.isGobalDownloadEnable !== false} onGlobalDownload={handleGlobalDownloadSupplementalInformation} globalDownloadTitle={supplementary?.supplementalInformationHeader?.globalDownloadTitle || supplementary?.supplementalInformationHeader?.downloadTitle} selectedDataModel={chartData?.selectedDataModel} />

                      <SimpleTableViewer {...props} name={supplementary?.supplementalInformation?.name} selectedTableDataElement={supplementary?.supplementalInformation?.dataElement?.TableSelectedDataElement} dataObj={blockState?.supplementalInformation ? blockState?.supplementalInformation : []} isObjectTable={false} isActionEnabled={true} isEditButton={true} isDeleteButton={true} onEdit={handleEditModeInfoModel} onDelete={handleDeleteModeInfoModel} isViewButton={true} onView={handleViewAttachments} blockState={blockState} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} isContractUnavailable={chartData?.isContractUnavailable} />

                      <HeadingBarViewer {...props} title={supplementary?.attachmentsHeader?.title} buttonLabel={supplementary?.attachmentsHeader?.actionButton?.label} isAttachmentsButton={supplementary?.attachmentsHeader?.isAttachmentsButton} blockState={blockState} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} attachmentsDataModel={supplementary?.attachments?.dataModel} blockConfig={supplementary?.attachments} selectedDataModel={chartData?.selectedDataModel} />

                      <SimpleTableViewer {...props} name={supplementary?.attachments?.name} action={false} selectedTableDataElement={supplementary?.attachments?.dataElement} dataObj={attachments} isObjectTable={false} isActionEnabled={true} isDownloadButton={true} onDownload={handleDownloadAttachments} isDeleteButton={true} onDelete={handleDeleteAttachments} blockState={blockState} enableWorkflow={typeof workflowEnable !== 'undefined' ? workflowEnable : false} isContractUnavailable={chartData?.isContractUnavailable} />

                      <SupplementalCommentsViewer {...props} removeIdFields={removeIdFields} blockState={blockState} sideBar={props.data.chartData.sidebar} supplementalCommentsInfo={supplementary?.supplementalComments} />

                      <SupplementalInfoModel {...props} open={isInfoModel} handleCloseModel={handleCloseModeInfoModel} formDataElements={supplementary?.supplementalInformation?.dataElement?.formSelectedDataElement} handleOnFieldChange={handleOnSupplementalInfoModelFieldChange} formData={formDataModeInfoModel} options={[]} selectedStep={{}} editingIndex={editingIndex} handleSave={handleSaveModeInfoModel} />
                    </div>
                  )}
                </Grid>
              )
            }
          </Grid>
        </Grid>
      </div>
    )

  );
};

export default ObligationViewer;
